import betSlips from './betSlips';
import Cookies from 'js-cookie';
import {onLCP, onINP, onCLS} from 'web-vitals';

import { getData, addDataToBetslip } from './main';

export const bsConfig = new betSlips(betslipData);

// The betslip configuration variable that defines the attribute that the code will use to trigger the betslip.
const addBetslip = bsConfig.bsToggle ? document.querySelectorAll(bsConfig.bsToggle) : '';

const cookieName = '_bsBet';
const cookieModalName = bsConfig.bsCookieModal ? bsConfig.bsCookieModal : '_bsModal'
const cookieModalExpires = bsConfig.bsCookieModalExpire ? Number(bsConfig.bsCookieModalExpire) : 7

/* ----------------------------------------------------------------------------
 This section creates the event listeners for the Odds Scope Dropdown change
---------------------------------------------------------------------------- */
    if (bsConfig.bsSport === 'covers') {
        const oddsData = document.querySelectorAll("#OddsScopeDropdown li a");
        const oddsDataMobile = document.querySelectorAll("#MobileOddsScopeDropdown li a");
        const oddScopeChange = document.getElementById("oddsScopeChangeField");

        if (oddsData && oddScopeChange) {
            oddScopeChange.addEventListener('change', (event) => {
                (bsConfig.bsDebug) ? console.log('Input value changed!') : null;
                initiateSlip();
            });
            oddsData?.forEach((oddsScope) => {
                (bsConfig.bsDebug) ? console.log('clicked oddsScope dropdown') : null;
                oddsScope.addEventListener("click", (event) => setTimeout(function() {initiateSlip() }, 3000));
            });
        }
        if (oddsDataMobile) {
            oddsDataMobile?.forEach((oddsScope) => {
                oddsScope.addEventListener("click", (event) => triggerBtn())
            });
        }
    }

    function triggerBtn() {
        (bsConfig.bsDebug) ? console.log('clicked mobile oddsScope dropdonw') : null;

        const btnOddsMobile = document.querySelector(".__oddsSetting #confirm-btn")

        if (btnOddsMobile) {
            btnOddsMobile.addEventListener("click", (event) => setTimeout(function() {initiateSlip() }, 3000));
        }
    }


    function initiateSlip() {
        (bsConfig.bsDebug) ? console.log('initiateSlip') : null;

        if (bsConfig.bsToggle) {
            const addBetslip = document.querySelectorAll(bsConfig.bsToggle);

            addBetslip?.forEach((itemsOdd) => {
                itemsOdd.addEventListener("click", (event) => getData(event, bsConfig, cookieName));
            })
        }
    }

/* ----------------------------------------------------------------------------
                            On load Event listener 
---------------------------------------------------------------------------- */
window.addEventListener('load', () => { 
    if (bsConfig.bsDebug) {
        onCLS(console.log);
        onINP(console.log);
        onLCP(console.log);
    }
    
    // if the bsTrigger is equal none, it will not show the betslip
    if (bsConfig.bsTrigger !== 'none') {
        if (bsConfig.bsOnBoardingModal && !Cookies.get(cookieModalName)) {
                bsConfig.modal()        // if the cookie has not being created, the onboarding messge will be rendered
        } else {
            setupBetslip()
        }
    }
    
});

/* ----------------------------------------------------------------------------
        Close Onboarding message and set the onboarding cookie 
---------------------------------------------------------------------------- */
export const closeModal = () => {
    bsConfig.destroy()
    document.body.classList.remove("bs-open", "modal-open")

    Cookies.set(
        cookieModalName, 
        1, 
        { 
            expires: cookieModalExpires, 
            secure: true,
            sameSite: 'strict' 
        }
    )
    setupBetslip()
}


/* ----------------------------------------------------------------------------
        Function that handles the initialization of the 
        betslip preact rendering and sets the event listeners 
        for the table cell odds
---------------------------------------------------------------------------- */

function setupBetslip() {
    if (bsConfig.bsToggle) {
        bsConfig.init()
        if (Cookies.get(cookieName)) {
            const cookieVal = Cookies.get(cookieName);
            addDataToBetslip(bsConfig, cookieName, cookieVal);
        }

        
        addBetslip?.forEach((itemsOdd) => {
            itemsOdd.addEventListener("click", (event) => getData(event, bsConfig, cookieName));
        });
    }
}
